module.exports = __webpack_public_path__ + "img/img_ranking999_L.733618ed.png";